'use strict';

angular.module('app', [
    'ngAnimate',
    'ngAria',
    'ngCookies',
    'ngMessages',
    'ngResource',
    'ngSanitize',
    'ngStorage',
    'ui.router',
    'ui.bootstrap',
    'uiGmapgoogle-maps',
    'pascalprecht.translate',
    'toaster',
    'perfect_scrollbar',
    'btorfs.multiselect',
    'moment-picker',
    'angular.bind.notifier',
    'rzModule',
    'tmh.dynamicLocale',
    'eee-c.angularBindPolymer',
    'ngclipboard',
    'cp.ngConfirm',
    'angularResizable',
    'ui.sortable',
    'color.picker',
    'angularjs-dropdown-multiselect',
    'constants',
]);
